import React from 'react'
import { toast } from 'react-toastify'
import SubmitSalesService from './../../shared/SubmitSales.service'
import ContentHtml from './../../../../components/content/ContentHtml/ContentHtml.component'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import { MDBBtn, MDBSpinner, MDBCard, MDBRow, MDBCol, MDBCardBody } from 'mdb-react-ui-kit'

import './SalesGuidelines.scss'

class SalesGuidelines extends React.Component {
  state = {
    fetching: true,
    guidelines: null,
    submitting: false,
    hasAccepted: false,
  }

  /*
   * Component Accessor Methods ----------------------
   *
   */

  /*
   * Component Public Methods ------------------------
   *
   */

  /*
   * Component Private Methods -----------------------
   *
   */
  _close = () => this.props.open('form')

  _checkUserHasAcceptedGuidelines = async () => {
    let accepted = await SubmitSalesService.hasUserAcceptedGuidelines(UserProfileService.getUserId())
    this.props.hasAccepted(accepted)

    // dont show acceptance guidelines if the
    // sale is being viewed by an admin user.
    if (UserProfileService.isAssumed()) return this.props.open('form')

    if (this.state.submitting === true) this.setState({ submitting: false })

    this.setState({ hasAccepted: !!accepted })
    return this.props.open(accepted ? 'form' : 'guidelines')
  }

  _acceptGuidelines = () => {
    this.setState({ submitting: true })
    SubmitSalesService.acceptGuidelines()
      .catch(error => toast.error(error.message, { position: toast.POSITION.BOTTOM_RIGHT }))
      .finally(() => this._checkUserHasAcceptedGuidelines())
  }

  _renderAcceptBtn = () => {
    if (!this.state.fetching) {
      if (UserProfileService.isAssumed())
        return (
          <MDBBtn
            type='button'
            disabled={this.state.submitting}
            color='primary'
            className='btn-block'
            onClick={() => this._close()}
            style={{ marginBottom: '1rem' }}
          >
            Close Sales Guidelines
          </MDBBtn>
        )
      return (
        <MDBBtn
          type='button'
          disabled={this.state.submitting}
          color='primary'
          className='btn-block'
          onClick={() => (this.state.hasAccepted ? this._close() : this._acceptGuidelines())}
          style={{ marginBottom: '1rem' }}
        >
          {this.state.hasAccepted
            ? 'Close Sales Guidelines'
            : this.state.submitting
            ? 'Accepting ...'
            : 'Accept Sales Guidelines'}
        </MDBBtn>
      )
    }
  }

  /*
   * Component Event Methods -------------------------
   *
   */
  componentDidMount() {
    this._checkUserHasAcceptedGuidelines()
  }

  componentWillUnmount() {}

  render() {
    toast.configure()

    const { fetching, guidelines } = this.state

    return (
      <div className='SalesGuidelines'>
        <MDBCard>
          <div className='header pt-3 indigo lighten-1'>
            <MDBRow className='d-flex justify-content-start'>
              <h3 className='white-text mt-3 mb-4 pb-1 mx-5'>USABG Sales Guidelines</h3>
            </MDBRow>
          </div>
          <MDBCardBody className='mx-4 mt-4'>
            <div className='integrity-statement-wrapper'>
              <ContentHtml contentSlug='sales-tracker-integrity-statement' onLoad={() => {}} />
            </div>
            <div>
              <ContentHtml
                contentId='31'
                modalSize='xl'
                onLoad={() => {
                  if (this.state.fetching)
                    this.setState(prevState => ({
                      ...prevState,
                      fetching: false,
                    }))
                }}
              />
            </div>
            {this._renderAcceptBtn()}
          </MDBCardBody>
        </MDBCard>
      </div>
    )
  }
}

export default SalesGuidelines
